import MascotBackground from '../MascotBackground';

export interface ISidebarMascotsProps {
    opacity?: number;
    density?: number;
    seed?: number;
    /** Цвет маскотов; без значения — как у фона входа */
    color?: string;
}

/** Россыпь маскотов на фоне панели меню (`sidebarDecoration` у AppShell): композиция на ширину развёрнутой панели. */
const SidebarMascots = ({ opacity = 0.1, density = 14000, seed, color }: ISidebarMascotsProps) => (
    <MascotBackground
        className="sidebar__mascots"
        color={color}
        opacity={opacity}
        density={density}
        gap={10}
        sizeMin={40}
        sizeMax={130}
        seed={seed}
        stagger={25}
        duration={700}
    />
);

export default SidebarMascots;
